import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { colors } from 'design-system';

/**
 * This gem over here was made this way because sonarcloud has a weird complain about repeated css properties.
 * This is actually an incorrect sonarcloud configuration, but it probably won't be fixed, so the best
 * we can do is work around it...
 *
 * The rule is basically that you cannot "repeat" a string value 3 or more times in the same file, regardless
 * of how this value is defined/calculated.
 */
type flexStart = 'flex-start';
type center = 'center';
type vertical = 'vertical';
type horizontal = 'horizontal';
const verticalVal: vertical = 'vertical';
const flexStartVal: flexStart = 'flex-start';
const centerVal: center = 'center';

type Props = {
  message: string;
  requesting: boolean;
  variant?: vertical | horizontal;
  whiteVariant?: boolean;
};

type AlignTypes = flexStart | center;

const NetworkIndicator = ({
  message,
  requesting,
  variant = verticalVal,
  whiteVariant = false,
}: Props): JSX.Element => {
  let justify: AlignTypes = flexStartVal;
  let alignItems: AlignTypes = centerVal;
  if (variant === verticalVal) {
    justify = centerVal;
    alignItems = flexStartVal;
  }

  let color = colors.madison;
  if (whiteVariant) {
    color = colors.white;
  }

  let indicatorContent = (
    <>
      <CircularProgress size={24} style={{ color }} />
      &nbsp;&nbsp;&nbsp;
      <Typography variant="caption" style={{ color }}>
        {message}
      </Typography>
    </>
  );
  if (variant === verticalVal) {
    indicatorContent = (
      <span
        data-testid="wrapper-span"
        style={{
          textAlign: centerVal,
          paddingTop: 16,
          color,
        }}
      >
        <CircularProgress data-testid="progress" style={{ color }} />
        <br />
        <br />
        <Typography data-testid="message" variant="caption" style={{ color }}>
          {message}
        </Typography>
      </span>
    );
  }

  if (requesting) {
    return (
      <Grid
        item
        xs={12}
        container
        justifyContent={justify}
        alignItems={alignItems}
      >
        {indicatorContent}
      </Grid>
    );
  }
  return <div />;
};

export default NetworkIndicator;
